import { ShippingOperationConfig } from 'stylewhere/shared'
import { Extensions } from './Extensions'

export class ConveyorExtensions extends Extensions {
  static initializeConveyor = async (conveyorId: string, operation: ShippingOperationConfig) => {}
}
